interface PromiseFulfilledResult<T> {
  status: 'fulfilled';
  value: T;
}

interface PromiseRejectedResult {
  status: 'rejected';
  reason: any;
}

type PromiseReturnType<T extends Promise<any>> = T extends Promise<infer R> ? R : never

type PromiseSettledResult<T> = PromiseFulfilledResult<T> | PromiseRejectedResult;

export function allSettled<T extends Promise<any>[]>(values: T): Promise<(PromiseSettledResult<PromiseReturnType<T[number]>>)[]> {
  // @ts-ignore ts 3.4 没有 allSettled 方法，注释掉ts的报错才能打包
  if (Promise.allSettled) return Promise.allSettled(values)
  return Promise.all(values.map(p => p.then(
    value => ({ status: 'fulfilled' as const, value }),
    reason => ({ status: 'rejected' as const, reason })
  ))) as any
}
